import { createContext, type ReactNode, useCallback, useContext, useMemo, useState } from "react";

import { EarlyAccessModal } from "./index";

interface EarlyAccessContextValue {
	open: () => void;
	close: () => void;
	isOpen: boolean;
}

const EarlyAccessContext = createContext<EarlyAccessContextValue | null>(null);

export function EarlyAccessProvider({ children }: { children: ReactNode }): ReactNode {
	const [isOpen, setIsOpen] = useState(false);

	const open = useCallback((): void => {
		setIsOpen(true);
	}, []);

	const close = useCallback((): void => {
		setIsOpen(false);
	}, []);

	const value = useMemo(
		(): EarlyAccessContextValue => ({ open, close, isOpen }),
		[open, close, isOpen],
	);

	return (
		<EarlyAccessContext.Provider value={value}>
			{children}
			<EarlyAccessModal open={isOpen} onClose={close} />
		</EarlyAccessContext.Provider>
	);
}

export function useEarlyAccess(): EarlyAccessContextValue {
	const ctx = useContext(EarlyAccessContext);
	if (!ctx) {
		throw new Error("useEarlyAccess must be used within EarlyAccessProvider");
	}
	return ctx;
}
